import React from 'react';

import Grid from '@mui/material/Grid2'; // Grid version 2
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import { ProductCard } from '../card';

type ProductListingProps = {
  products: readonly Queries.ShopifyProductCardFragment[]
  location: Location
}

export function ProductListing({ products = [], location }: ProductListingProps) {
  // console.log('heree products listing', products)
  return (
    (<Grid container spacing={3}
      alignItems="center"
      justifyContent="center">
      {products.map((p, index) => (
        <Grid
          key={p.shopifyId}
          alignItems={"stretch"}
          size={{
            xs: 12,
            sm: 12,
            md: 6,
            lg: 6,
            xl: 6
          }}>
          <ProductCard location={location} product={{ ...p, seo1x1Image: undefined, seo4x3Image: undefined, seo16x9Image: undefined }} eager={index === 0} pageType={AnalyticsPageType.collection} />
        </Grid>
      ))}
    </Grid>)
  );
}
